interface TokenLifetime {
  issuedAtMs: number
  expiresAtMs: number
}

const readLifetime = (token: string): TokenLifetime | undefined => {
  try {
    const payload = token.split('.')[1] ?? ''
    const claims: unknown = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    if (typeof claims !== 'object' || claims === null) return undefined
    if (!('iat' in claims) || !('exp' in claims)) return undefined
    const { iat, exp } = claims
    if (typeof iat !== 'number' || typeof exp !== 'number') return undefined
    return { issuedAtMs: iat * 1000, expiresAtMs: exp * 1000 }
  } catch {
    return undefined
  }
}

// The smallest gap seen between the browser clock and a token's issue time. Clerk issued every
// token before the browser saw it, so the browser clock runs ahead of Clerk's by at most this much,
// and `Date.now() - clockLeadMs` never passes Clerk's real time even on a device set wrong.
let clockLeadMs = Number.POSITIVE_INFINITY

/**
 * Re-measures the clock lead from a token Clerk minted on request, so a browser clock corrected
 * forward stops making fresh tokens look expired.
 */
export const measureClockLead = (freshToken: string): void => {
  const lifetime = readLifetime(freshToken)
  if (lifetime) clockLeadMs = Date.now() - lifetime.issuedAtMs
}

/**
 * True only when the token's expiry has certainly passed on Clerk's clock; unreadable tokens pass.
 * Each call also lowers the clock lead when this token shows the browser runs closer to Clerk.
 */
export const hasExpired = (token: string): boolean => {
  const lifetime = readLifetime(token)
  if (!lifetime) return false
  const now = Date.now()
  clockLeadMs = Math.min(clockLeadMs, now - lifetime.issuedAtMs)
  return now - clockLeadMs >= lifetime.expiresAtMs
}
